import { render, staticRenderFns } from "./LeaveBtn.vue?vue&type=template&id=c829b15e&"
import script from "./LeaveBtn.vue?vue&type=script&lang=js&"
export * from "./LeaveBtn.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports